import {isN2OrHigher, isN3User, isSavUser} from '../utils/functions';

export const isDevicesAndSimsVisible = webUserJson => isN2OrHigher(webUserJson) || isSavUser(webUserJson);

export const isAdminVisible = webUserJson => isN2OrHigher(webUserJson);

// TODO: add isN2TechnicalUser when needed
export const isMaintenanceVisible = webUserJson => isN3User(webUserJson);